<template>
  <div class="area-division">
    <title-one :title="title || ''" :ps-txt="psTxt" />
    <div class="rank-one left">
      <area-item v-for="(item, index) in list" :key="index" :item="item | changeArea" />
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import AreaItem from '@/views/Home/components/AreaItem'
export default {
  name: 'AreaDivision',
  components: { AreaItem, TitleOne },
  filters: {
    changeArea: (value) => {
      return {
        ...value,
        src: require(`../../images/${value.icon}`)
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    psTxt: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-one{
    width: 100%;
    height: 202px;
    padding: 30px 40px 20px;
    background: url("../../images/left-1.png") top left no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
